import cn from 'clsx';
import { FC } from 'react';

import Icon from '../../Icon';

import s from './SelectTextField.module.scss';

export interface SelectTextFieldProps {
  value: string;
  placeholder: string;
  disabled?: boolean;
  error?: boolean;
  success?: boolean;
  onClick: () => void;
  className?: string;
}

const SelectTextField: FC<React.PropsWithChildren<React.PropsWithChildren<SelectTextFieldProps>>> = ({
  value,
  placeholder,
  onClick,
  className = '',
  success = false,
  disabled = false,
  error = false
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        s.button,
        {
          [s.error as string]: error,
          [s.disabled as string]: disabled
        },
        className
      )}
      disabled={disabled}
    >
      <p className={s.text}>{value ? <span className={s.value}>{value}</span> : <span className={s.placeholder}>{placeholder}</span>}</p>
      {success && (
        <span className={s.icon}>
          <Icon type="check-mark" color="green.600" size={24} />
        </span>
      )}
      <span className={s.icon}>
        <Icon type="expand-more" color="gray.500" size={24} />
      </span>
    </button>
  );
};

export default SelectTextField;
